<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title moduleIdentifier="tikTokShop" :title="$t('tikTokShop.account.label')">
        <div class="btnGroup" slot="header-right">
          <button @click="changeStatus(false)" v-bind:class="{ 'is-active': !tikTokShopAccount.active }" class="btn btn--info btn--outline">
            Inativo
          </button>
          <button @click="changeStatus(true)" v-bind:class="{ 'is-active': tikTokShopAccount.active }" class="btn btn--info btn--outline">
            Ativo
          </button>
        </div>
      </page-title>
      <div class="l-row vertical-flex">
        <div class="l-col-3@md img-account">
          <img v-if="tikTokShopAccount.logo" :src="tikTokShopAccount.logo"/>
          <i v-if="!tikTokShopAccount.logo" class="icon-image2 no-photo"/>
        </div>
        <div class="l-col-9@md">
          <panel title="Dados da conta">
            <span class="ds-block"><strong>Nome:</strong> {{ tikTokShopAccount.nickname }}</span>
          </panel>
        </div>
      </div>
      <div class="l-row">
        <div class="l-col-12@md">
          <panel title="Autenticação">
            <div slot="header-right">
              <button class="hint hint--left btn" @click="refreshToken" data-label="Renovar token"><i class="icon-sync icon-loop2"></i></button>
            </div>
            <span class="ds-block"><strong>Token de acesso:</strong> {{ tikTokShopAccount.accessToken }}</span>
            <span class="ds-block"><strong>Token de renovação:</strong> {{ tikTokShopAccount.refreshToken }}</span>
            <span class="ds-block"><strong>Data de expiração:</strong> {{ tikTokShopAccount.expirationDate.replace('.000Z', '') | moment('DD/MM/YYYY HH:mm') }}</span>
          </panel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import ModuleLogo from '@/components/template/ModuleLogo'
  import notifier from '@/notifier'
  import api from '@/api'
  import Panel from '@/components/template/Panel'

  export default {
    props: {
      identifier: {
        type: String,
        required: false
      }
    },
    data: () => ({
      tikTokShopAccount: {},
      loading: true
    }),
    async mounted () {
      if (!this.account) {
        await this.fetchAccounts({})
      }

      this.loading = false
    },
    methods: {
      ...mapActions('tikTokShopAccounts', [
        'fetchAccounts',
        'setAccount'
      ]),
      isActive () {
        return {
          'success': this.tikTokShopAccount.active,
          'error': !this.tikTokShopAccount.active
        }
      },
      getStatusLabel (status) {
        if (status) {
          return 'tikTokShop.accounts.active.label'
        }
        return 'tikTokShop.accounts.inactive.label'
      },
      editAction () {
        return this.$router.push(`/` + this.tikTokShopAccount.identifier)
      },
      async refreshToken () {
        this.loading = true

        try {
          const refreshedAccount = (await api.tikTokShop.refreshTokenManually(this.tikTokShopAccount.identifier))

          this.tikTokShopAccount = refreshedAccount

          this.setAccount(refreshedAccount)

          this.loading = false

          notifier.success(`Token da conta renovado com sucesso.`, 'Sucesso')
        } catch (error) {
          this.loading = false

          notifier.error('Erro na renovação do token da conta.', 'Erro')
        }
      },
      async changeStatus (status) {
        this.loading = true

        if (this.tikTokShopAccount.active === status) {
          this.loading = false

          return false
        }

        try {
          await api.tikTokShop.updateAccountStatus(this.tikTokShopAccount.identifier, status)

          this.tikTokShopAccount.active = status

          this.loading = false

          notifier.success(`Status da conta alterado com sucesso.`, 'Sucesso')
        } catch (error) {
          this.loading = false

          notifier.error('Erro na alteração de status da conta.', 'Erro')
        }
      }
    },
    computed: {
      ...mapGetters('tikTokShopAccounts', [
        'getAccount'
      ]),
      async account () {
        this.tikTokShopAccount = await api.tikTokShop.getAccountByIdentifier(this.identifier)
        return this.tikTokShopAccount
      }
    },
    components: {
      Loader,
      PageTitle,
      ModuleLogo,
      Panel
    }
  }
</script>

<style lang="sass" scoped>
  .img-account
    text-align: center
    padding: 30px 0

    img
      max-height: 100%
      margin: 5px 0 16px
      max-width: 150px

    .no-photo
      font-size: 150px
      color: darkgrey
</style>



// WEBPACK FOOTER //
// Edit.vue?4b94ac18